module.exports = __webpack_public_path__ + "img/minus.a0cd2c54.svg";